import type { McpToolResponse } from '../types';

export const ResearchMcpApi = Symbol('ResearchMcpApi');

export interface ResearchMcpApi {
    callTool<T>(
        name: string,
        args: Record<string, unknown>,
        options: { signal?: AbortSignal; timeoutMs: number }
    ): Promise<McpToolResponse<T>>;
}
